import { getCurrentUser } from "../services/auth";

const permissions = [
    {
        role:'driver',
        paths: ['/home', '/jobs', '/clients', '/calendar', '/route-plan', '/notifications', '/profile']
    },
    {
        role:'staff',
        paths: ['/jobs', '/clients', '/calendar', '/materials', '/route-plan', '/notifications', '/profile']
    },
    {
        // Technicians open My Route like drivers do (route stops can be
        // assigned to either).
        role:'cleaner',
        paths: ['/home', '/jobs', '/clients', '/calendar', '/route-plan', '/notifications', '/profile']
    },
    {
        role:'order_desk',
        paths: ['/home', '/jobs', '/clients', '/calendar', '/services', '/materials', '/route-plan', '/notifications', '/profile']
    }
]

export const isUserAllowed = (path) => {

    const curUser = getCurrentUser();

    if(!curUser || !curUser.activeRoles) return false

    if(curUser.activeRoles.includes('admin')) return true//matic na

    const perm = permissions.filter(x => curUser.activeRoles.includes(x.role))
    if(!perm || !perm.length) return false

    return perm.some(x => x.paths.includes(path))
}

// Field roles (Driver, Technician) see "My Route" instead of "Route Plan"
// and only their own assigned routes / jobs.
export const isFieldUser = () => {
    const curUser = getCurrentUser()
    const roles = curUser?.activeRoles || []
    return !roles.includes('admin') && (roles.includes('driver') || roles.includes('cleaner'))
}

// Administrator, Coordinator, Dispatcher — the roles that may create jobs and
// clients, send intake links and manage tracking links (docs/permissions.md).
export const isOfficeUser = () => {
    const roles = getCurrentUser()?.activeRoles || []
    return ['admin', 'staff', 'order_desk'].some((role) => roles.includes(role))
}

export const isUserAdmin = () => {
    const curUser = getCurrentUser()
    return curUser?.activeRoles?.includes('admin') || false
}